import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PageSection, IconCheckGreen } from 'adc-ui-components';

import HowToReturn from '../HowToReturn';
import ReturnStatusIndicator from '../ReturnStatusIndicator';
import ReturnDevices from './ReturnDevices';
import ShippingLabels from './ShippingLabels';
import CancelMessage from './CancelMessage';
import { getIsCancelationRequired } from '../../helpers/order';

import { flagEnabled } from '../../helpers/featureFlags';
import { RETURNS_SELECT_DEVICE } from '../../helpers/routes';

class Confirmation extends Component {
  componentDidMount() {
    const { handleResetConfirmation } = this.props;

    handleResetConfirmation();
  }

  render() {
    const {
      returnData, email, newLabelLoading, handleFetchNewLabel,
    } = this.props;

    if (!returnData) return <Redirect to={RETURNS_SELECT_DEVICE} />;

    const { returnInitiation, returnOrderId, isXfiPods } = returnData;
    const { shippingLabels, devices, returnMethod } = returnInitiation;
    const hasEnoughLabels = shippingLabels.length >= devices.length;
    const returnReasons = returnInitiation.devices.map(device => device.returnReason);
    const showCovidMessages = flagEnabled('global.showCovidMessages', { defaultValue: false });

    return (
      <PageSection className="return-detail-confirmation ui-grey">
        <div className="text--center">
          <IconCheckGreen className="mb6 svg-icon--42" />

          {returnMethod.toLowerCase() === 'ups' && (
            <>
              <h1 className="heading2 mb12">Your prepaid shipping label is ready!</h1>
              {showCovidMessages
                ? (
                  <p className="body2 mb30">
                    Please note: there may be delays due to COVID-19.
                    <br />
                    For quick, accurate tracking, visit My Account.
                  </p>
                )
                : <p className="body2 mb30">You can track your return anytime from My Account.</p>
          }
            </>
          )}

          {returnMethod === 'xfinityStore' && (
            <>
              <h1 className="heading2">
                {'We\'ll see you soon!'}
              </h1>
              <p className="body1">We look forward to seeing you soon. Please find details about your return below.</p>
            </>
          )}
        </div>


        {!!shippingLabels.length && (
        <div className="card-group mb12">
          <div className="card-group__item">
            <div className="card card--action-right-at-768">
              <div className="card__content">
                <h3 className="heading3">
                  {`Return #${returnOrderId}`}
                </h3>
              </div>
              <div className="card__action">
                <ReturnStatusIndicator status="In Progress" />
              </div>
            </div>
          </div>

          <ShippingLabels
            labels={shippingLabels}
            loading={newLabelLoading}
            handleFetchNewLabel={handleFetchNewLabel}
            returnOrderId={returnOrderId}
            showGenerateLabel={!hasEnoughLabels}
          />

        </div>
        )}

        {(getIsCancelationRequired(returnReasons) || isXfiPods) && (
        <CancelMessage
          showCancel={getIsCancelationRequired(returnReasons)}
        />
        )}

        <div className="card-group">
          {returnInitiation.returnSource === 'MyAccount'
        && <HowToReturn context={returnMethod} />
        }
        </div>

        <div className="card-group">
          <ReturnDevices
            devices={devices}
            returnInitiation={returnInitiation}
            showStatus={!isXfiPods}
            showDeviceSummary={!isXfiPods}
          />
        </div>

        <div className="card-group">
          <div className="card-group__item">
            <div className="card">
              <div className="card__content">
                <h3>What to Expect</h3>
              </div>
            </div>
          </div>
          <div className="card-group__item">
            <div className="card card--secondary">
              <div className="card__content">
                <p>
                  It may take up to 45 days for this return to be reflected on your account.
                  {' We\'ll email '}
                  <span data-notranslate>{email}</span>
                  {' with any updates about your return. '}
                  Please note: My Account is the quickest, best way to track shipments at this time.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="action action--centered">
          <a className="button" href="/">Back to My Account</a>
        </div>
      </PageSection>
    );
  }
}

export default Confirmation;
